import { render, staticRenderFns } from "./verificationUser.vue?vue&type=template&id=65003240"
import script from "./verificationUser.vue?vue&type=script&lang=ts"
export * from "./verificationUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports